// extracted by mini-css-extract-plugin
export default {"modal":"withdrawModal_modal__-R09u"};